




import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Spacer extends Vue {
  @Prop() private msg!: string;
}
